// extracted by mini-css-extract-plugin
module.exports = {"Image":"styles_Image__V7hyf","placeholder":"styles_placeholder__SldNf","light":"styles_light__PjnZd","dark":"styles_dark__Jp1BI"};